// extracted by mini-css-extract-plugin
module.exports = {"background":"_06mii","confirm":"QX7ep","dialogue":"wn2hx"};